/*
* Pipeline Theme — SAVINA Custom JS
*/

(function() {

  var cartJustAdded = false;

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (btn) {
      cartJustAdded = true;
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    if (!event.detail.cart) return;

    // Invalida cache da Yampi quando carrinho muda
    if (typeof yampiCachedUrl !== 'undefined') {
      yampiCachedUrl = null;
      yampiCacheExpiry = null;
      if (typeof prefetchYampiUrl === 'function') {
        setTimeout(prefetchYampiUrl, 500);
      }
    }

    if (!cartJustAdded) return;
    cartJustAdded = false;

    setTimeout(function() {
      var cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
      if (cartDrawer) {
        cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
      }

      var notification = document.querySelector('[data-product-add-popdown-wrapper]');
      if (notification) {
        notification.style.display = 'none';
        notification.style.opacity = '0';
        notification.style.visibility = 'hidden';
      }
    }, 50);
  });

  document.addEventListener('theme:drawer:open', function() {
    // Pre-fetch URL da Yampi quando drawer abre
    if (typeof prefetchYampiUrl === 'function') {
      prefetchYampiUrl();
    }
  });

})();